module.exports = __webpack_public_path__ + "img/app-logo.0bd6918e.svg";